import { mapActions } from 'vuex';
import urlParser from '../utils/urlParser';

export default {
  name: 'MainViewTabMixin',
  props: {
    path: {
      type: String,
      required: true,
    },
  },
  methods: {
    urlParser,
    ...mapActions('mainView', [
      'updateTabTitle',
    ]),
  },
};

